import { Typography } from '@tunasong/ui-lib'
import { Poll as PollIcon } from '@tunasong/icons'
import { isOneOfManyPoll, isOneOfManyPollResponse } from '@tunasong/schemas'
import type { OneOfManyPollResponse } from '@tunasong/schemas'
import type { FC } from 'react'
import invariant from 'tiny-invariant'
import type { PollProps } from '../poll.js'
import { getProgress } from '../progress-util.js'
import Progress from '../progress.js'
import { PollOptionName } from '../poll-option-name.js'
import { graphHooks } from '@tunasong/graph-lib/react'
import styles from './view.module.css'

export const OneOfManyPollView: FC<PollProps> = props => {
  const { poll, userId } = props

  invariant(isOneOfManyPoll(poll), `Poll must be a OneOfManyPoll`)

  const { entities: responses = [], isSuccess } = graphHooks.useEntityChildren<OneOfManyPollResponse>({
    parentId: poll.id,
    filter: isOneOfManyPollResponse,
  })
  const userResponse = responses.find(response => response.userId === userId)

  const hasVoted = isSuccess && Boolean(userResponse)

  const { name = 'Untitled', pollOptions = [], finalOption } = poll

  const numResponses = Object.keys(responses).length

  return (
    <div className={styles.container}>
      <Typography variant="subtitle1" className={styles.title}>
        <PollIcon /> {name}
      </Typography>
      {poll.closed && (
        <Typography variant="caption" color="secondary">
          The Poll is closed.
        </Typography>
      )}
      <Typography variant="caption">{numResponses} participants.</Typography>

      {pollOptions.map((option, idx) => (
        <div key={idx}>
          <PollOptionName option={option} />
          {hasVoted ? <Progress value={getProgress(poll, responses, idx)} selected={idx === finalOption} /> : null}
        </div>
      ))}
    </div>
  )
}
